import { useEffect, useState, useRef } from "react";
import {
  useDeleteBusinessBox,
  useGetBusinessBoxV2,
} from "../../../../../services/mutations";
import { getLoggedInUser, transformedText } from "../../../../../utils/helpers";
import { Box, Fade, Grid, Menu, Paper, Stack, Typography } from "@mui/material";
import { FaEllipsisV } from "react-icons/fa";
import { colors } from "../../../../../utils";
import { FaPlus, FaSpinner } from "react-icons/fa6";
import { motion } from "framer-motion";
import "./style.css";
import { toast } from "react-toastify";
import { businessBoxInitialValues } from "../../../../NewBusinessBox/BusinessBoxHelpers";
import { isEmpty } from "lodash";
import { useSelector, useDispatch } from "react-redux";
import Edit from "@assets/images/editIcon.svg";
import Delete from "@assets/images/delete2.png";
import { isVideoUrl } from "../../../../../utils/validations";
import { useFormikContext } from "formik";
import { updateProfileBusinessBox } from "../../../../../redux/reducers/gallery";
import {
  pushToHistoryAction,
  setBusinessBoxWheel,
} from "../../../../../redux/reducers/segmentBuilder";
import CheckIcon from "@mui/icons-material/Check";

const MenuItem = ({ children, onClick, isLast = false }) => {
  return (
    <motion.div
      whileHover={{ backgroundColor: "#f0f0f0" }}
      whileTap={{ scale: 0.9 }}
      onClick={onClick}
      style={
        isLast
          ? {
              padding: "0.5rem",
              cursor: "pointer",
            }
          : {
              padding: "0.5rem",
              cursor: "pointer",
              borderBottom: "1px solid #e0e0e0",
            }
      }
    >
      <Typography
        variant="body2"
        sx={{
          color: "#333",
          fontSize: "14px",
        }}
      >
        {children}
      </Typography>
    </motion.div>
  );
};

//janky solution for video thumbnails, these should be stored on server side
const VideoThumbnail = ({ url }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [isYouTube, setIsYouTube] = useState(false);
  const [thumbnailURL, setThumbnailURL] = useState(null);

  useEffect(() => {
    // Check if the URL is a YouTube embed link
    const regex = /youtube\.com\/embed\/([^"&?\/\s]{11})/;
    const match = url.match(regex);

    if (match && match[1]) {
      const videoID = match[1];

      // Construct the thumbnail URL for YouTube video
      const thumbnail = `https://img.youtube.com/vi/${videoID}/hqdefault.jpg`;

      setThumbnailURL(thumbnail);
      setIsYouTube(true); // Set isYouTube to true to indicate it's a YouTube video
    } else {
      setIsYouTube(false); // Set isYouTube to false for non-YouTube videos
    }
  }, [url]);

  useEffect(() => {
    if (!isYouTube) {
      const videoElement = videoRef.current;
      const canvasElement = canvasRef.current;
      const context = canvasElement.getContext("2d");

      // Wait for the video to load metadata
      videoElement.addEventListener("loadeddata", () => {
        // Seek to the 1st second
        videoElement.currentTime = 1;
      });

      // When video seek is complete, draw the frame to the canvas
      videoElement.addEventListener("seeked", () => {
        context.drawImage(
          videoElement,
          0,
          0,
          canvasElement.width,
          canvasElement.height
        );
      });

      // Cleanup event listeners
      return () => {
        videoElement.removeEventListener("loadeddata", () => {});
        videoElement.removeEventListener("seeked", () => {});
      };
    }
  }, [isYouTube]);

  return (
    <div>
      {isYouTube ? (
        <img
          src={thumbnailURL}
          alt="YouTube Video Thumbnail"
          style={{
            width: "100%",
            height: "100px",
            margin: "auto",
            objectFit: "cover",
            borderRadius: "2px",
          }}
        />
      ) : (
        <>
          <video
            ref={videoRef}
            src={url}
            style={{ display: "none" }}
            controls
          ></video>
          <canvas
            ref={canvasRef}
            style={{
              margin: "auto",
              objectFit: "cover",
              borderRadius: "2px",
            }}
            width="100"
            height="100"
          ></canvas>
        </>
      )}
    </div>
  );
};

function BusinessBoxManager({
  bBox,
  setter,
  closeManager,
  isWheelBusinessBox,
  currentBBox,
  handleBusinessBoxPermissions,
}) {
  const dispatch = useDispatch();
  const defaultBboxId = useSelector((state) => {
    if (!isEmpty(state.gallery.profile?.business_box)) {
      return state.gallery?.profile?.business_box.id;
    } else return null;
  });

  const { setValues, resetForm } = useFormikContext();

  const getBusinessBox = useGetBusinessBoxV2();
  const deleteBox = useDeleteBusinessBox();

  const [anchorEl, setAnchorEl] = useState(null);
  const [activeBoxId, setActiveBoxId] = useState(null);

  const handleClose = () => {
    setAnchorEl(null);
    setActiveBoxId(null);
  };

  const [boxes, setBoxes] = useState();
  const [businessBoxApiLoading, setBusinessBoxApiLoading] = useState(true);
  const deleteBusinessBox = (id) => {
    deleteBox.mutate(
      { id: id },
      {
        onSuccess: (response) => {
          if (response.status === 204) {
            // Check if the deleted box is the currently selected one
            if (currentBBox && currentBBox.id === id) {
              if (isWheelBusinessBox) {
                dispatch(setBusinessBoxWheel(null));
                dispatch(pushToHistoryAction());
              } else {
                dispatch(updateProfileBusinessBox({ updates: null }));
              }
              console.log("selectedBBox ke andar");
              // setValues(null);
              // setter(null);
              // resetForm();
            }
            setValues(null);
            setter(null);
            resetForm();
            toast("Business Box deleted", { type: "success" });
            //remove from state if succesful
            setBoxes((prev) => prev.filter((box) => box.id !== id));
          }
        },
        onError: (err) => {
          toast("An error occured while deleting business box", {
            type: "error",
          });
          console.error(err);
        },
      }
    );
    handleClose();
  };

  const getBusinessBoxData = () => {
    setBusinessBoxApiLoading(true);
    var userId = getLoggedInUser()?.id;
    getBusinessBox.mutate(
      { userid: userId },
      {
        onSuccess: (response) => {
          if (response?.status === 200) {
            setBoxes(response?.data?.results);
            setBusinessBoxApiLoading(false);
          }
        },
        onError: (err) => {
          console.error("getBusinessBox Error:::", err);
          setBusinessBoxApiLoading(false);
        },
      }
    );
  };

  useEffect(() => {
    getBusinessBoxData();
    return () => {
      //if the current bBox is in Edit Mode, do not cleanup
      //if it is, set it to initial values
      if (bBox && !bBox.isEditMode) {
        setter(businessBoxInitialValues);
      }
    };
  }, []);

  useEffect(() => {
    setActiveBoxId(defaultBboxId);
    if (defaultBboxId && boxes) {
      const _boxes = [...boxes];
      //if there's a default box set, transpose the array
      const idx = _boxes.findIndex((box) => box.id === defaultBboxId);
      if (idx > 0) {
        setter(boxes[idx]);
        const [matchedBox] = _boxes.splice(idx, 1);
        _boxes.unshift(matchedBox);
        setBoxes(_boxes);
      }
    }
  }, [defaultBboxId, boxes]);

  const BoxIcon = ({ onClick, img }) => {
    return (
      <Paper
        onClick={onClick}
        elevation={3}
        sx={{
          padding: 1,
          maxWidth: "120",
          maxHeight: "120",
          backgroundColor: "#F7F8FA",
          borderRadius: "2px",
          border: "1px solid #E1E1E1",
          transition: "box-shadow 0.3s ease-in-out",

          "&:hover": {
            boxShadow: "0 0 15px rgba(0, 0, 0, 0.3)",
          },
        }}
      >
        {img ? (
          isVideoUrl(img) ? (
            <VideoThumbnail url={img} />
          ) : (
            <Box
              component="img"
              src={img}
              alt={"bbox-icon"}
              sx={{
                width: "100%",
                height: 100,
                objectFit: "cover",
                borderRadius: "2px",
              }}
            />
          )
        ) : (
          <>
            <Grid container spacing={1} direction="column" alignItems="center">
              <Grid item>
                <Box
                  sx={{
                    width: 90,
                    height: 25,
                    backgroundColor: "#D3D3C9",
                    borderRadius: "6px",
                  }}
                />
              </Grid>

              <Grid item>
                <Box
                  sx={{
                    width: 90,
                    height: 10,
                    backgroundColor: "#697384",
                    borderRadius: "6px",
                  }}
                />
              </Grid>

              <Grid item container justifyContent="center" spacing={1}>
                <Grid item>
                  <Box
                    sx={{
                      width: 90,
                      height: 4,
                      backgroundColor: "#E5E7EB",
                      borderRadius: "4px",
                    }}
                  />
                </Grid>
                <Grid item>
                  <Box
                    sx={{
                      width: 65,
                      height: 4,
                      backgroundColor: "#E5E7EB",
                      borderRadius: "4px",
                    }}
                  />
                </Grid>
              </Grid>

              {/* Bottom Large Red Box */}
              <Grid item>
                <Box
                  sx={{
                    width: 80,
                    height: 12,
                    backgroundColor: "#FF6F61",
                    borderRadius: "6px",
                  }}
                />
              </Grid>

              {/* Circular Dots at Bottom */}
              <Grid item container justifyContent="center" spacing={1}>
                {[...Array(5)].map((_, index) => (
                  <Grid item key={index}>
                    <Box
                      sx={{
                        width: 5,
                        height: 5,
                        backgroundColor: "#AEDCE3",
                        borderRadius: "50%",
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </>
        )}
      </Paper>
    );
  };

  if (businessBoxApiLoading) {
    return (
      <FaSpinner
        color={colors.PrimaryPurple700}
        style={{ padding: "0.2rem", animation: "rotate 2s linear infinite" }}
        size={50}
      />
    );
  }

  return (
    <Grid
      height="100%"
      mx="0.2rem"
      mt={"0.2rem"}
      maxWidth={"95%"}
      container
      spacing={2}
    >
      <Grid
        spacing={1}
        item
        xs={12} // Full width on small screens
        sm={6} // Two columns on medium screens (600px and above)
        md={boxes?.length >= 2 ? 4 : 6} // Three columns on larger screens (960px and above)
        key="new-box"
        sx={{
          cursor: "pointer",
          pr: 1,
          transition: "transform 0.3s ease-in-out",
          "&:hover": {
            transform: "scale(1.05)",
          },
        }}
      >
        <Box
          onClick={() => {
            setter(null);
            resetForm();
            closeManager();
          }}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
            alignItems: "center",
            height: "134px",
            maxWidth: "134px",
            backgroundColor: "#F6F7F9",
            borderRadius: "4px",
            border: "1px solid #F9FAFB",

            transition: "box-shadow 0.3s ease-in-out",

            "&:hover": {
              boxShadow: "0 0 15px rgba(0, 0, 0, 0.3)",
            },
          }}
        >
          <Box
            sx={{
              height: "32px",
              width: "32px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              border: "1px solid #E1E1E1",
              borderRadius: "4px",
              backgroundColor: "white",
            }}
          >
            <FaPlus
              size={18}
              style={{
                color: colors.PrimaryPurple700,
              }}
            />
          </Box>
          <Typography
            mx="auto"
            marginTop="0.6rem"
            textAlign="center"
            color={colors.PrimaryPurple700}
            fontSize={"14px"}
            fontWeight={700}
          >
            Create New
          </Typography>
        </Box>
      </Grid>
      {boxes?.map((boxItem, idx) => {
        const open = Boolean(anchorEl);

        return (
          <Grid
            spacing={1}
            item
            xs={12} // Full width on small screens
            sm={6} // Two columns on medium screens (600px and above)
            md={boxes.length >= 2 ? 4 : 6} // Three columns on larger screens (960px and above)
            key={idx}
            sx={{
              transition: "transform 0.3s ease-in-out",
              "&:hover": {
                transform: "scale(1.05)",
              },
            }}
          >
            <Box
              elevation={0}
              sx={
                (bBox && boxItem.id === bBox.id) || boxItem.id === activeBoxId
                  ? {
                      p: 0.25,
                      border: "2px solid" + colors.PrimaryPurple700,
                      borderRadius: "4px",
                    }
                  : null
              }
            >
              <BoxIcon
                onClick={() => {
                  setActiveBoxId(boxItem.id);
                  setter({
                    isEditMode: false,
                    id: boxItem.id,
                    business_title: boxItem.business_title || "Untitled",
                    description: boxItem.description || "No description",
                    media_url: boxItem.media_url,
                    business_box_cta: boxItem.business_box_cta || [],
                    business_link: boxItem.business_link || [],
                  });
                  setValues({
                    isEditMode: false,
                    id: boxItem.id,
                    business_title: boxItem.business_title || "Untitled",
                    description: boxItem.description || "No description",
                    media_url: boxItem.media_url,
                    business_box_cta: boxItem.business_box_cta || [],
                    business_link: boxItem.business_link || [],
                  });
                }}
                img={boxItem.media_url}
              />
              <Stack
                flexDirection={"row"}
                style={{
                  marginTop: "0.6rem",
                  position: "relative",
                }}
                justifyContent={"space-between"}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "700",
                    color: "#000000",
                  }}
                >
                  {transformedText(boxItem.business_title) || "Untitled"}
                </Typography>

                <FaEllipsisV
                  color="black"
                  style={{ cursor: "pointer", width: "8px" }}
                  onClick={(event) => {
                    setAnchorEl(event.currentTarget);
                    setActiveBoxId(boxItem.id);
                  }}
                />

                <Menu
                  key={idx}
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open && activeBoxId === boxItem.id}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  TransitionComponent={Fade}
                  timeout={{ enter: 100, exit: 300 }}
                  PaperProps={{
                    style: {
                      padding: "0.5rem",
                      borderRadius: "8px",
                      width: "150px",
                      transition: "box-shadow 0.3s ease-in-out",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                    },
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      setter({
                        isEditMode: true,
                        id: boxItem.id,
                        business_title: boxItem.business_title || "",
                        business_link: boxItem.business_link || [],
                        description: transformedText(boxItem.description) || "",
                        media_url: boxItem.media_url || "",
                        business_box_cta: boxItem.business_box_cta || [],
                        closeManager: true,
                      });
                      setValues({
                        isEditMode: true,
                        id: boxItem.id,
                        business_title: boxItem.business_title || "",
                        business_link: boxItem.business_link || [],
                        description: transformedText(boxItem.description) || "",
                        media_url: boxItem.media_url || "",
                        business_box_cta: boxItem.business_box_cta || [],
                        closeManager: true,
                      });
                      handleClose();
                    }}
                    sx={{
                      fontSize: "14px",
                      padding: "0.6rem 1rem",
                      color: "#333",
                      "&:hover": {
                        backgroundColor: "#f0f0f0",
                      },
                    }}
                  >
                    <img
                      style={{ marginRight: "0.2rem" }}
                      src={Edit}
                      className="img-fluid"
                      alt="Edit"
                      width="15"
                      height="15"
                    />
                    Edit
                  </MenuItem>
                  <MenuItem
                    onClick={() => deleteBusinessBox(boxItem.id)}
                    sx={{
                      fontSize: "14px",
                      padding: "0.6rem 1rem",
                      color: "#333",
                      "&:hover": {
                        backgroundColor: "#f0f0f0",
                      },
                    }}
                  >
                    <img
                      style={{ marginRight: "0.2rem" }}
                      src={Delete}
                      className="img-fluid"
                      alt="Delete"
                      width="15"
                      height="15"
                    />
                    Delete
                  </MenuItem>
                  <MenuItem
                    isLast
                    onClick={() => {
                      setter({
                        id: boxItem.id,
                        business_title: boxItem.business_title || "",
                        business_link: boxItem.business_link || [],
                        description: transformedText(boxItem.description) || "",
                        media_url: boxItem.media_url || "",
                        business_box_cta: boxItem.business_box_cta || [],
                      });
                      setValues({
                        id: boxItem.id,
                        business_title: boxItem.business_title || "",
                        business_link: boxItem.business_link || [],
                        description: transformedText(boxItem.description) || "",
                        media_url: boxItem.media_url || "",
                        business_box_cta: boxItem.business_box_cta || [],
                      });
                      handleClose();
                      handleBusinessBoxPermissions({ showDialogAlways: true });
                    }}
                    sx={{
                      fontSize: "14px",
                      padding: "0.6rem 1rem",
                      marginBottom: "10px",
                      color: "#333",
                      "&:hover": {
                        backgroundColor: "#f0f0f0",
                      },
                    }}
                  >
                    <CheckIcon
                      sx={{
                        marginRight: "0.2rem",
                        width: "15px",
                        height: "15px",
                      }}
                      className="img-fluid"
                    />
                    Assign
                  </MenuItem>
                </Menu>
              </Stack>
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
}

export default BusinessBoxManager;
